/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Pr_Wins_6Inputs */

const en_fc_vs_pr_wins_6 = /** @type {(inputs: Fc_Vs_Pr_Wins_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens native .prproj projects shared by clients and teams.`)
};

/**
* | output |
* | --- |
* | "Opens native .prproj projects shared by clients and teams." |
*
* @param {Fc_Vs_Pr_Wins_6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_pr_wins_6 = /** @type {((inputs?: Fc_Vs_Pr_Wins_6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Pr_Wins_6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_pr_wins_6(inputs)
});
export { fc_vs_pr_wins_6 as "fc.vs.pr_wins.6" }